<template>
  <div class="card no-border" style="margin-bottom: 1rem">
    <div class="card-section no-padding">
      <div class="grid-x grid-padding-x align-middle">
        <div 
          :class="(orientation == 'horizontal' ? ['small-4'] : ['small-12'])"
          class="cell">
          <img 
            v-if="item.image_url" 
            :src="item.image_url"
            class="square rounded" />
        </div>
        <div 
          :class="(orientation == 'horizontal' ? ['small-8'] : ['small-12'])"
          class="cell">
          <div class="profile">
            <h4 v-html="item.formatted_name"></h4>
            <h6 v-if="item.specialties">
              {{specialties}}
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Provider',
  props: {
    item: {
      type: Object,
      required: true
    },
    orientation: {
      type: String
    }
  },
  methods: {
    stringify (items) {
      return this.$util.itemsToString(items)
    }
  },
  computed: {

    specialties () {
      return this.stringify(this.item.specialties)
    }
  }
}
</script>
